import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatPaginator, MatTableDataSource } from '@angular/material';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppConstants } from 'src/app/shared/constants/app.contants';
import { AlertService, MessageSeverity } from 'src/app/shared/services/alert.service';
import { SensorTypeService } from 'src/app/services/sensor-type/sensor-type.service';

@Component({
  selector: 'app-cause-plan-crud-modal',
  templateUrl: './cause-plan-crud-modal.component.html',
  styleUrls: ['./cause-plan-crud-modal.component.css']
})
export class CausePlanCrudModalComponent implements OnInit{
  item: any = { name: '' }; // Asegúrate de tenerlo así para evitar undefined
  title: string = '';
  color: string = '#1976d2'; // Valor por defecto
  colorFont: string = '#ffffff'; // Valor por defecto
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<any>, private service: SensorTypeService) {}

  ngOnInit(): void {
  if (this.data && this.data.item) {
      this.item = { ...this.data.item };
      this.title = `Editar ${this.data.type === 'cause' ? 'Causa' : 'Plan de acción'}`;
    } else {
      this.item = { name: '' };
      this.title = `Nueva ${this.data.type === 'cause' ? 'Causa' : 'Plan de acción'}`;
    }

    if (this.data && this.data.color) this.color = this.data.color;
    if (this.data && this.data.colorFont) this.colorFont = this.data.colorFont;
  }

  save() {
    const payload = {
      ...this.item,
      idDeviation: this.data.idDeviation
    };

    const call = this.data.type === 'cause'
      ? (payload.id ? this.service.updateDeviationCause(payload) : this.service.createDeviationCause(payload))
      : (payload.id ? this.service.updateDeviationActionPlan(payload) : this.service.createDeviationActionPlan(payload));

    call.subscribe(() => this.dialogRef.close({ refresh: true }));
  }
}
